export default __webpack_public_path__ + "static/media/nub-cigar2.c4d58b5a.jpg";